import { TokenWithBalance } from '@/domain/common/types'
import { CheckedAddress } from '@/domain/types/CheckedAddress'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { raise } from '@/utils/assert'

export class TokensInfo {
  constructor(private readonly tokens: TokenWithBalance[]) {}

  all(): TokenWithBalance[] {
    return this.tokens
  }

  filter(predicate: (token: TokenWithBalance) => boolean): TokenWithBalance[] {
    return this.tokens.filter(predicate)
  }

  findTokenBySymbol(symbol: TokenSymbol): Token | undefined {
    return this.tokens.find(({ token }) => token.symbol === symbol)?.token
  }

  findOneTokenBySymbol(symbol: TokenSymbol): Token {
    return this.findTokenBySymbol(symbol) ?? raise(`Token with symbol ${symbol} not found`)
  }

  findBalanceBySymbol(symbol: TokenSymbol): NormalizedUnitNumber | undefined {
    return this.tokens.find(({ token }) => token.symbol === symbol)?.balance
  }

  findOneBalanceBySymbol(symbol: TokenSymbol): NormalizedUnitNumber {
    return this.findBalanceBySymbol(symbol) ?? raise(`Balance for symbol ${symbol} not found`)
  }

  findTokenWithBalanceBySymbol(symbol: TokenSymbol): TokenWithBalance | undefined {
    return this.tokens.find(({ token }) => token.symbol === symbol)
  }

  findOneTokenWithBalanceBySymbol(symbol: TokenSymbol): TokenWithBalance {
    return this.findTokenWithBalanceBySymbol(symbol) ?? raise(`Token with symbol ${symbol} not found`)
  }

  findOneTokenWithBalanceBySymbolCaseInsensitive(symbol: TokenSymbol): TokenWithBalance | undefined {
    return this.tokens.find(({ token }) => token.symbol.toLowerCase() === symbol.toLowerCase())
  }

  findTokenByAddress(address: CheckedAddress): Token | undefined {
    return this.tokens.find(({ token }) => token.address === address)?.token
  }

  findOneTokenByAddress(address: CheckedAddress): Token {
    return this.findTokenByAddress(address) ?? raise(`Token with address ${address} not found`)
  }
}
